import { render, staticRenderFns } from "./BadgeAwardWidget.vue?vue&type=template&id=17524a7f&"
import script from "./BadgeAwardWidget.vue?vue&type=script&lang=js&"
export * from "./BadgeAwardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports